import Vue from 'vue'
// 权限指令
Vue.directive('has', {
  bind(el, binding) {
    if (!Vue.prototype.$_has(binding.expression)) {
      el.parentNode.removeChild(el);
    } 
  } });
// 权限检查方法
Vue.prototype.$_has = function(value) {
  value = value.slice(1, -1);
  let isExist = false;
  let btnPermissionsStr = sessionStorage.getItem('btnPermissions');
  if (btnPermissionsStr === undefined || btnPermissionsStr == null) {
    return false;
  }
  
  let btnPermissions = JSON.parse(btnPermissionsStr)
  if (btnPermissions !== null && btnPermissions.length > 0) {
    for (let i = 0; i < btnPermissions.length; i++) {
      if (btnPermissions[i].path === value) {
        isExist = true;
        break;
      }
    }
  }
  return isExist;
};



// WEBPACK FOOTER //
// ./src/utils/btnPermissions.js